/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmployeeAttributeData
 */
export interface CreateEmployeeAttributeData {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeAttributeData
     */
    name: string;
}

/**
 * Check if a given object implements the CreateEmployeeAttributeData interface.
 */
export function instanceOfCreateEmployeeAttributeData(value: object): value is CreateEmployeeAttributeData {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateEmployeeAttributeDataFromJSON(json: any): CreateEmployeeAttributeData {
    return CreateEmployeeAttributeDataFromJSONTyped(json, false);
}

export function CreateEmployeeAttributeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeeAttributeData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

  export function CreateEmployeeAttributeDataToJSON(json: any): CreateEmployeeAttributeData {
      return CreateEmployeeAttributeDataToJSONTyped(json, false);
  }

  export function CreateEmployeeAttributeDataToJSONTyped(value?: CreateEmployeeAttributeData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

